import { render, staticRenderFns } from "./DelayIcon.vue?vue&type=template&id=6f2f1a52"
import script from "./DelayIcon.vue?vue&type=script&lang=ts"
export * from "./DelayIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports